import React from 'react';

export const UserCheckIcon = ({
  width = '20',
  height = '18',
  color = '#101828',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    fill={'none'}
    viewBox="0 0 20 18"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M13.3335 16.5V14.8333C13.3335 13.9493 12.9823 13.1014 12.3572 12.4763C11.7321 11.8512 10.8842 11.5 10.0002 11.5H4.16683C3.28277 11.5 2.43493 11.8512 1.80981 12.4763C1.18469 13.1014 0.833496 13.9493 0.833496 14.8333V16.5M14.1668 8.16667L15.8335 9.83333L19.1668 6.5M10.4168 4.83333C10.4168 6.67428 8.92444 8.16667 7.0835 8.16667C5.24255 8.16667 3.75016 6.67428 3.75016 4.83333C3.75016 2.99238 5.24255 1.5 7.0835 1.5C8.92444 1.5 10.4168 2.99238 10.4168 4.83333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
